import { DirectMessage, User } from 'model';
import { BaseApi } from './BaseAPI';

export const baseURL = 'directMessage/';
const DirectMessageApi = BaseApi.injectEndpoints({
	endpoints: builder => ({
		getDirectMessage: builder.query<DirectMessage, DirectMessage['_id']>({
			query: id => ({
				url: `${baseURL}/${id}`
			}),
			providesTags: result => {
				return result?._id ? [{ type: 'Direct Message', id: result?._id }] : [];
			}
		}),
		searchRecipients: builder.query<User[], string>({
			query: search => ({
				url: `${baseURL}recipients/${search}`
			}),
			providesTags: result => {
				return result?.map(({ _id }: User) => ({ type: 'User', id: _id })) ?? [];
			}
		})
	})
});
export const {
	useSearchRecipientsQuery,
	useLazySearchRecipientsQuery,
	useGetDirectMessageQuery,
	useLazyGetDirectMessageQuery
} = DirectMessageApi;
